import React, { useContext, useEffect, useState } from "react";
import Field from "../core/ui/forms/field";
import DualSelect from "partials/dual-select";
import SessionContext from "SessionContext";
import { Link, useHistory } from "react-router-dom";
import SearchableDropdown from "../core/ui/simple-dropdown-search";
import ProgressLoader from "../partials/progress-loader";
import { loaderStyle, animatedStyle } from "../core/ui/forms/file-uploader";
import dayjs from "dayjs";
import { Form, FormGroup, Input, Button, Modal, Alert, ModalHeader, ModalBody, ModalFooter, Table } from "reactstrap";
import SimpleDropdown from "../core/ui/simple-dropdown";
import ConfirmSuccess from "../core/ui/confirm-success";
import isEqual from "lodash.isequal";
import UnsavedChanges from "partials/unsaved-changes";
import InfoPopover from "../core/ui/info-popover";
import { CostLimitList } from "partials/CostLimitList";
import SoftErrorModal from "partials/soft-errors";

const textStyle = {
  position: 'absolute',
  top: '25%',
  left: '25%',
  width: '50%',
  padding: '35px 0',
  textAlign: 'center',
  zIndex: '1002',
  fontWeight: 'bold',
  background: 'white',
  borderRadius: '10px'
};

export default function CompanyForm(props) {
  const session = useContext(SessionContext);
  const access = session.appState.userCan;
  const history = useHistory();

  const [company, setCompany] = useState({
    id: "",
    name: "",
    code: "",
    qb_name: "",
    sftp_directory: "",
    delivery_options: [],
    headquarter_location: null,
    headquarter_location_id: 0,
    override_license_requirement: false,
    override_license_requirement_reason: "",
    demo_instance: false,
    disable_banner: false
  });

  const [errors, setErrors] = useState({
    id: "",
    name: "*Required",
    code: "*Required",
    qb_name: "*Required",
    sftp_directory: "",
    delivery_options: "*Required",
    headquarter_location: ""
  });
  
  const [companyFirstLoad, setCompanyFirstLoad] = useState(null);
  const [allDataPermissions, setAllDataPermissions] = useState([]);
  const [selectedDataPermissions, setSelectedDataPermissions] = useState([]);
  const [allInvoiceCategories, setAllInvoiceCategories] = useState([]);
  const [selectedInvoiceCategories, setSelectedInvoiceCategories] = useState([]);
  const [createBucketsDisabled, setCreateBucketsDisabled] = useState(true);
  const [missingFields, setMissingFields] = useState(true);
  const [isUploading, setIsUploading] = useState(false);
  const [updatingMessage, setUpdatingMessage] = useState("");
  const [updateSuccess, setUpdateSuccess] = useState(false);
  const [nextInvoice, setNextInvoice] = useState();
  const [companyLocations, setCompanyLocations] = useState();
  const [validSftp, setValidSftp] = useState(true);
  const [newSftpDir, setNewSftpDir] = useState("");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [isLoadingCompany, setIsLoadingCompany] = useState(true);
  const [showSuccess, setShowSuccess] = useState(false);
  const [deliveryOptionsList, setDeliveryOptionsList] = useState([]);
  const [showLicenseOverrideModal, setShowLicenseOverrideModal] = useState(false);
  const [overrideLicenseReason, setOverrideLicenseReason] = useState("");
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [showSubCompanyModal, setShowSubCompanyModal] = useState(false);
  const [showOrderCostOptions, setShowOrderCostOptions] = useState(false);
  const [showLinkUncheckedWarning, setShowLinkUncheckedWarning] = useState(false);
  const [showLinkedWarning, setShowLinkedWarning] = useState(false);
  const [parentCompanyInfo, setParentCompanyInfo] = useState(null);
  const [activeSubCompanies, setActiveSubCompanies] = useState(0);
  const [showActiveSubCompanyWarning, setShowActiveSubCompanyWarning] = useState(false);
  const [showActiveSubCompanyWarningOnDelete, setShowActiveSubCompanyWarningOnDelete] = useState(false);
  const [costLimitOptions, setCostLimitOptions] = useState([]);
  const [showOrderLimitWarning, setShowOrderLimitWarning] = useState(false);
  const [costLimits, setCostLimits] = useState([]);
  const [disableDemoField, setDisableDemoField] = useState(false);
  const [initialLoadComplete, setInitialLoadComplete] = useState(false);
  const default_subcompanies_allowed = 10;
  const [disableSftpCheck, setDisableSftpCheck] = useState(true);
  const [isValidatingSftp, setIsValidatingSftp] = useState(false);
  const [sftpValidationResponse, setSftpValidationResponse] = useState("");
  const [softErrors, setSoftErrors] = useState([]);
  const [showSoftErrorModal, setShowSoftErrorModal] = useState(false);
  const [hasDestinationsInUse, setHasDestinationsInUse] = useState(false);
  const [hasDisabledDestinationsOnly, setHasDisabledDestinationsOnly] = useState(false);
  const [showExternalDestinationsWarning, setShowExternalDestinationsWarning] = useState(false);
  const [externalDestinationsMessage, setExternalDestinationsMessage] = useState("This company has External Destinations set up. Please delete before removing these permissions.");
  const [colorSchemeOptions, setColorSchemeOptions] = useState([]);

  useEffect(() => {
    if (company.data_permissions && company.data_permissions.length && allDataPermissions) {
      setSelectedDataPermissions(
        company.data_permissions.map((cp) => {
          const a =
            allDataPermissions.find((p) => cp.data_permission_id === p.id) ||
            {};
          return { ...a, value: cp.value };
        })
      );
    }
  }, [company.data_permissions, allDataPermissions]);

  useEffect(() => {
    if (company.pricing && company.pricing.length && allInvoiceCategories) {
      setSelectedInvoiceCategories(
        company.pricing.map((cp) => {
          const a =
            allInvoiceCategories.find((p) => cp.invoice_category_id === p.id) ||
            {};
          let p = { ...a };
          p.unit_price = cp.unit_price;
          return { ...p, value: p.unit_price };
        })
      );
      if (company.sftp_directory) {
        setNewSftpDir(company.sftp_directory);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [company.pricing, allInvoiceCategories]);

  function loadCompany(company_id) {

    // get data permissions
    function getAllDataPermissions() {
      session
        .query("reference/permissions/data")
        .then((permissions) => {
          setAllDataPermissions(
            permissions && permissions.map((v) => {
              return { ...v, value: "" };
            })
          );
        });
    }

    // get invoice categories
    function getInvoiceCategories() {
      session
        .query("reference/codes/invoiceCategories")
        .then((codes) => {
          setAllInvoiceCategories(
            codes && codes.map((v) => {
              return { ...v, value: v.unit_price };
            })
          );
        });
    }

    // get current license fee
    function getCurrentLicenseFee() {
      session
        .query("admin/get_current_licence_fee", { am_company_id: company_id })
        .then((response) => {
          if (response !== undefined) {
            setNextInvoice(response);
          }
        });
    }

    // get data delivery options
    function setDataDeliverySelected() {
      let _options_list = [];
      let _default_list = [];

      session.query("order/get_default_delivery_options", {id: company_id})
      .then((_defaults) => {
        _default_list = _defaults;
      })
      .then(() => {
        session.query("admin/get_delivery_options")
        .then((_options) => {
          _options.forEach((_option) => {
            _options_list.push({..._option, checked: false})
          })
          if(Object.keys(_default_list) ) {
            _default_list.forEach((val) => {
              _options_list.forEach((_check) => {
                if(_check.id === val.id) {
                  _check.checked = true;
                }
              })
            })
          }
          setDeliveryOptionsList(_options_list.reverse());
        })
      })
    }

    // get cost limit data options
    function getCostLimitDataOptions() {
      let _options_list = [];

      session.query("reference/get_order_cost_limit_periods")
      .then((_defaults) => {
        _options_list = _defaults;
        setCostLimitOptions(_options_list);
      })
    }

    // get color scheme options
    function getColorSchemeOptions() {
      session.query("reference/get_color_schemes")
        .then((schemes) => {
          setColorSchemeOptions(schemes || []);
        });
    }

    // get all company data to edit
    if(company_id) {
      session
      .query("companies/get", { id: company_id })
        .then((response) => {
        setCompany({ ...response, code: response.code.toLowerCase() });
        setActiveSubCompanies(response.active_sub_company_count || 0);
        getAllDataPermissions();
        getInvoiceCategories();
        getCurrentLicenseFee();
        setDataDeliverySelected();
        loadLocations(company_id);
        getCostLimitDataOptions();
        getColorSchemeOptions();
        setCostLimits();
        setNewSftpDir(response.sftp_directory)
      })
      .catch((error) => {
        console.log("Failed to Load Company", JSON.stringify(error));
      })
      .finally(() => doneLoading());
    } else {
      // get data company to create new
      getInvoiceCategories();
      getAllDataPermissions();
      getColorSchemeOptions();
      doneLoading();
    }
  }

  const doneLoading = () => {
    setTimeout(() => {
      setIsLoadingCompany(false)
    }, 1000);
  }

  useEffect(() => {
    if(!parentCompanyInfo && !isLoadingCompany) {
      let parent_id = (company && company.parent) ? company.parent.id : null;

      parent_id && session.query("companies/get", { id: parent_id })
      .then((response) => {
        setParentCompanyInfo(response);
      })
      .catch((error) => {
        console.log("Failed to get parent company info: ", error)
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoadingCompany])

  function loadLocations(company_id) {
    if(company_id) {
      session.query("location/get-locations-for-company", { company_id: company_id })
        .then((response) => {
        setCompanyLocations(response.rows);
        });
    }
  }

  useEffect(() => {
    let is_sftp_selected = company.delivery_options.some(item => /SpeedeonSFTP/i.test(item.name));
    
    // if sftp option is selected and it's not a demo instance
    if(is_sftp_selected && !company.demo_instance) {
      setSftpValidationResponse("");
      setDisableSftpCheck(false);
      if(!newSftpDir.length || newSftpDir === company.sftp_directory) {
        setDisableSftpCheck(true);
      }
    } else {
      !disableSftpCheck && setDisableSftpCheck(true);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [newSftpDir, company.delivery_options]);

  useEffect(() => {
    if (!company.link_order_cost_limit_to_parent) {
      setCostLimits(company.order_cost_limits || []);
    }else if(parentCompanyInfo && parentCompanyInfo.order_cost_limits) {
      setCostLimits(parentCompanyInfo.order_cost_limits || []);
    } else {
      setCostLimits([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [company.order_cost_limits, company.link_order_cost_limit_to_parent, parentCompanyInfo]);

  // Remove "External Destinations" from delivery options if a sub-company
  useEffect(() => {
    if (parentCompanyInfo && parentCompanyInfo.delivery_options) {
      let _options_list = [...deliveryOptionsList];
      _options_list = _options_list.filter((item) => {
        return item.id !== 4 // "External Destinations"
      });
      companyFirstLoad.delivery_options = companyFirstLoad.delivery_options.filter((item) => {
        return item.id !== 4 // "External Destinations"
      });
      if (company.delivery_options.some((item) => item.id === 4)) {
        setCompany({...company, delivery_options: company.delivery_options.filter((item) => item.id !== 4)});
      }
      !isEqual(_options_list, deliveryOptionsList) && setDeliveryOptionsList(_options_list);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [company.delivery_options, parentCompanyInfo ]);

  useEffect(() => {
    const company_id = props.args.company_id;
    if (company_id) {
      loadCompany(company_id);
    } else {
      loadCompany();
      let _options_list = [];
      session.query("admin/get_delivery_options")
      .then((_options) => {
        _options.forEach((_option) => {
          _options_list.push({..._option, checked: false})
        })
        setDeliveryOptionsList(_options_list.reverse());
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const checkForEmptyFields = () => {
    const hasDeliveryOption = deliveryOptionsList.some(item => item.checked);
    if (
      company.name === "" || company.code === "" ||
      company.qb_name === "" || !hasDeliveryOption
    ) {
      return true;
    }
    return false;
  }

  const hasSelectedPricingChanged = () => {
    /* returns true if changed */
    // get the IDs from the selected array
    let _selected = [];
    selectedInvoiceCategories && selectedInvoiceCategories.forEach(item => {
      let _id = (item && item.id && item.id.toString()) || "";
      let _price = (item && item.value && item.value.toString()) || "";
      _selected.push(_id + _price);
    });

    // get the IDs from the comp array
    let _current = [];
    companyFirstLoad.pricing && companyFirstLoad.pricing.forEach(item => {
      let _id = (item && item.invoice_category_id && item.invoice_category_id.toString()) || "";
      let _price = (item && item.unit_price && item.unit_price.toString()) || "";
      _current.push(_id + _price);
    });

    return !isEqual(_current, _selected)
  }

  const hasSelectedPermissionsChanged = () => {
    /* returns true if changed */
    // get the IDs from the selected array
    const _selected = selectedDataPermissions
      ? selectedDataPermissions.map(item => ({ id: item.id, value: item.value }))
      : [];

    // get the IDs from the comp array
    const _current = company.data_permissions
      ? company.data_permissions.map(item => ({ id: item.data_permission_id, value: item.value }))
      : [];

    return !isEqual(_current, _selected)
  }

  const checkSftpSelectedValid = () => {
    let _sftp_selected = company.delivery_options.some(item => /SpeedeonSFTP/i.test(item.name));
    if(!_sftp_selected) { return true; }
    if( company.sftp_directory === newSftpDir || newSftpDir === "" || !validSftp ) {
      return false;
    }
    return true;
  }
  
  useEffect(() => {
    let saveIsDisabled = true;

    const checkForChanges = () => {
      if(isLoadingCompany || !companyFirstLoad) {
        setTimeout(() => {
          checkForChanges();
        }, 200);
        return;
      }

      // compare original data with current
      let original_copy = JSON.parse(JSON.stringify(companyFirstLoad));
      let company_copy = JSON.parse(JSON.stringify(company));
      let _newSftpDir = newSftpDir;

      // update delivery_options structure to compare with what comes from api
      original_copy.delivery_options = original_copy.delivery_options.map(({ checked, ...rest }) => rest);
      company_copy.delivery_options = company_copy.delivery_options.map(({ checked, ...rest }) => rest);

      // remove pricing: pricing gets compared in a separate step
      company_copy && (company_copy.pricing = []);
      original_copy && (original_copy.pricing = []);

      const removeExternalDestinations = (_val) => {
        if(!_val) {return _val;}
        return _val.filter((item) => {
          return item.id !== 4 // "External Destinations"
        });
      }

      // if company has a parent: remove external destination option before comparing
      if(parentCompanyInfo && parentCompanyInfo.delivery_options) {
        original_copy.delivery_options = removeExternalDestinations(original_copy.delivery_options);
        company_copy.delivery_options = removeExternalDestinations(company_copy.delivery_options);
      }

      // check if delivery options changed
      if(!isEqual(original_copy.delivery_options, company_copy.delivery_options)) {
        // check if SFTP selected and valid
        if(company.delivery_options.some(item => /SpeedeonSFTP/i.test(item.name)) ) {
          if(newSftpDir === "" || !validSftp) {
            saveIsDisabled = true;
            return;
          }
        } else {
          saveIsDisabled = false;
          return;
        }
      } else if(!company.delivery_options.some(item => /SpeedeonSFTP/i.test(item.name))) {
        _newSftpDir = original_copy.sftp_directory;
      }

      // check if drag and drop fields changed - not required fields
      let isSubCompany = companyFirstLoad && companyFirstLoad.hasOwnProperty("parent");
      if(companyFirstLoad && !isSubCompany && hasSelectedPricingChanged()) {
        saveIsDisabled = false;
        return;
      }
      if(companyFirstLoad && hasSelectedPermissionsChanged()) {
        saveIsDisabled = false;
        return;
      }

      // check if the values are equal
      if( (isEqual(company_copy, original_copy)) && (isEqual(original_copy.sftp_directory, _newSftpDir)) ) {
        saveIsDisabled = true;
        return;
      } else {
        saveIsDisabled = false;
      }

    }

    // check for required empty fields
    if(checkForEmptyFields()) {
      saveIsDisabled = true;
      setMissingFields(true);
      return;
    }

    if(company.id) {
      checkForChanges();
    } else {
      // new company: check for required empty fields and sftp validation
      if(checkForEmptyFields() || !checkSftpSelectedValid()) {
        saveIsDisabled = true;
      } else {
        saveIsDisabled = false;
      }
    }

    setMissingFields(saveIsDisabled);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [company, selectedInvoiceCategories, selectedDataPermissions, deliveryOptionsList, validSftp]);

  useEffect(() => {
    if (softErrors.length > 0) {
      setShowSoftErrorModal(true);
    }
  }, [softErrors]);

  function toggleSoftErrorModal() {
    setShowSoftErrorModal(!showSoftErrorModal);
    setSoftErrors([]);
  }

  function updateDataPermissionsValue(ev, id) {
    setSelectedDataPermissions((prevValue) => {
      const field = prevValue.find((f) => f.id === id);
      field["value"] = ev.target.value;
      return [...prevValue];
    });
  }

  function updateInvoiceCategoryValue(ev, id) {
    let new_value;
    if (ev.target.value === "") {
      new_value =  "";
    } else {
      new_value = ev.target.value.replace(/[^0-9.]/g, ""); // remove any non-numeric characters except '.'
      new_value = new_value.replace(/^0+(?=\d)/, "0"); // allow a single leading zero but remove additional ones
    }
    // if input starts with '.', prepend '0'
    if (new_value.startsWith(".")) {
      new_value = "0" + new_value;
    }
    // update individual price
    let _updated = [...selectedInvoiceCategories];
    _updated.forEach((val) => {
      if(val.id === id) {
        val.value = new_value === "" ? "" : Number(new_value);
      }
    })    
    setSelectedInvoiceCategories(_updated);
  }

  function onClickSave(ev) {
    ev.stopPropagation();
    ev.preventDefault();
    setIsUploading(true);
    setUpdatingMessage("Updating... please wait");

    let _company = {...company};

    if(_company.demo_instance) {
      _company.override_license_requirement = true;
      _company.override_license_requirement_reason = "Set as Demo Instance";
      _company.delivery_options = [{"id": 3, "name": "Download", "checked": true}];
    } else {
      _company.override_license_requirement_reason = overrideLicenseReason
    }

    // reset to default count if user deselected checkbox
    if(!_company.allow_sub_companies) {
      _company.approved_sub_company_count = default_subcompanies_allowed;
    }

    // don't send pricing when linked to parent company
    if(_company.link_pricing_to_parent) {
      _company.pricing = [];
    }

    let newCompany = {
      ..._company,
      data_permissions: selectedDataPermissions && selectedDataPermissions.map((p) => {
        return {
          data_permission_id: p.id,
          value: p.value,
        };
      }),
      pricing: selectedInvoiceCategories && selectedInvoiceCategories.map((b) => {
        return {
          invoice_category_id: b.id,
          unit_price: b.value,
        };
      }),
    };

    if(newCompany.hasOwnProperty("headquarter_location") && newCompany.headquarter_location) {
      newCompany.headquarter_location_id = _company.headquarter_location.id;
    } else {
      newCompany.headquarter_location_id = 0;
    }

    if(newCompany.delivery_options.some(item => /SpeedeonSFTP/i.test(item.name)) && validSftp) {
      newCompany.sftp_directory = newSftpDir;
    }

    if (!!newCompany.id) {
      session
        .command(
          "companies/update",
          newCompany,
          {},
          { defaultErrorHandling: false }
        )
        .then((response) => {
          setSoftErrors(response.soft_errors || []);
          if (!response?.soft_errors?.length) {
            setCreateBucketsDisabled(true);
            // if editing our own active company, refresh the cached copy (used at
            // boot to pick the skin, among other things) before onUpdateSuccess
            // reloads - otherwise the reload races loadIdentity() and shows stale data.
            // Read from localStorage rather than session.appState.activeCompany:
            // the latter is populated async by loadIdentity() and can still be
            // undefined this soon after a page load, which would skip this entirely.
            let _storedActiveCompanyId;
            try {
              _storedActiveCompanyId = JSON.parse(localStorage.getItem("am:audience:active:company") || "{}").id;
            } catch { /* ignore */ }
            if (response.id === _storedActiveCompanyId) {
              // response.color_scheme only has `id` (name/code are null) - the API
              // builds a bare id-only reference to persist the FK and echoes that
              // same stub back, rather than the fully-loaded scheme. Use our own
              // already-correct copy (from the colorSchemeOptions dropdown) instead.
              session.appState.updateActiveCompany({...response, color_scheme: company.color_scheme});
            }
            onUpdateSuccess();
          } else {
            setIsUploading(false);
          }
        })
        .catch((error) => {
          console.log("Company Update Failed", JSON.stringify(error));
          setIsUploading(false);
        });
    } else {
      session
        .command(
          "companies/create",
          newCompany,
          {},
          { defaultErrorHandling: false }
        )
        .then((response) => {
          setSoftErrors(response.soft_errors || []);
          if (!response?.soft_errors?.length) {
            setCreateBucketsDisabled(true);
            onUpdateSuccess(true);
          } else {
            setIsUploading(false);
          }
        })
        .catch((error) => {
          console.log("Company Create Failed", JSON.stringify(error));
          setIsUploading(false);
        });
    }
  }

  function onUpdateSuccess(is_new=false) {
    setUpdatingMessage(is_new ? "Created Successfully" : "Updated Successfully");
    setUpdateSuccess(true);
    //Clear cache since company has changed
    session.crossfilterStore.clear_cache();
    setHasUnsavedChanges(false);
    setTimeout(() => {
      if(is_new) {
        // on create new: go back to list of all
        setIsUploading(false);
        history.push("/admin-companies");
      } else {
        // on edit: reload current to get updated info
        setIsUploading(false);
        window.location.reload();
      }
    }, 1000);
  }

  function setName(ev) {
    setCompany({ ...company, name: ev.target.value });
    if (ev.target.value) {
      setErrors((prev) => {
        const { name, ...rest } = prev;
        return rest;
      });
    }
  }

  function setCode(ev) {
    // field is blank
    if(ev.target.value === "") {
      setCompany({ ...company, code: "" });
      return;
    }
    let firstCharIsLetter = /^[a-zA-Z]/.test(ev.target.value);
    // only allow letters or numbers
    let allowed = /^[a-z0-9]+$/;
    if (allowed.test(ev.target.value) && firstCharIsLetter) {
      setCompany({ ...company, code: ev.target.value });
      if (ev.target.value) {
        setErrors((prev) => {
          const { code, ...rest } = prev;
          return rest;
        });
      }
    } else {
      if(!firstCharIsLetter) {
        setErrors(prev => ({ ...prev, code: "*Must begin with a letter" }));
      } else {
        setErrors(prev => ({ ...prev, code: "*Only Lower case letters and numbers allowed" }));
      }
    }
  }

  function setQbName(ev) {
    setCompany({ ...company, qb_name: ev.target.value });
    if (ev.target.value) {
      setErrors((prev) => {
        const { qb_name, ...rest } = prev;
        return rest;
      });
    }
  }

  function setHqLocation(ev) {
    setCompany({ ...company, headquarter_location: ev });
  }

  function validateSftpDirectory() {
    if(newSftpDir === "") { return; }
    setIsValidatingSftp(true);
    setDisableSftpCheck(true);

    // when creating a new company: use the active company code
    let _code = company.id ? company.code : session.appState.activeCompany.code;

    const x = session.crossfilterStore.validate_sftp_directory(_code, newSftpDir);
    x.then((res) => {
      if (res) {
        setErrors((prev) => {
          const { sftp_directory, ...rest } = prev;
          return rest;
        });
        setValidSftp(true);
        setIsValidatingSftp(false);
        setSftpValidationResponse("");
      } else {
        setValidSftp(false);
        setIsValidatingSftp(false);
        setSftpValidationResponse("Directory Not Found.");
      }
    });

  }

  function handleSftpDirChange(ev) {
    setSftpValidationResponse("");
    setValidSftp(false);
    setNewSftpDir(ev.target.value);
  }

  function createBuckets(ev) {
    ev.stopPropagation();
    ev.preventDefault();

    session
      .command(
        "companies/create_buckets",
        company,
        {},
        { defaultErrorHandling: false }
      )
      .then((response) => {
        setCreateBucketsDisabled(true);
      })
      .catch((error) => {
        setCreateBucketsDisabled(false);
        console.log("Company Failed to Create Buckets", JSON.stringify(error));
      });
  }

  function get_display_channel_options(invoice_category) {
    if ('channel_options' in invoice_category) {
      return invoice_category.channel_options.map((co) => co.name);
    } else {
      return;
    }
  }

  function checkIfExternalDestinationsInUse() {
    if(!company?.id) {return;}
    let _id = company.id;
    let _is_checked = companyFirstLoad?.delivery_options.some(item => item.id === 4);
    let _is_sub_company = company.parent ? true : false;

    /* when editing a company with the box unchecked: no need to call the api */
    if(!_is_checked || _is_sub_company) {
      return;
    }

    session.query("census/check-destinations-summary", { company_id: _id }).then((res) => {
      if (res.has_enabled_destinations) {
        setHasDestinationsInUse(true);
        setExternalDestinationsMessage("This company has External Destinations set up. Please delete before removing these permissions.");
      } else if (res.has_sub_company_enabled_destinations) {
        setHasDestinationsInUse(true);
        setExternalDestinationsMessage("This company has sub-companies with External Destinations set up. Please delete before removing these permissions.");
      } else if (res.has_disabled_only_destinations) {
        // allow to uncheck but ask to confirm
        setHasDisabledDestinationsOnly(true);
      }
    })
    .catch((error) => {
      console.log("Failed to check external destinations in use", JSON.stringify(error));
    });
  }

  function handleExternalDestinationsWarning() {
    setShowExternalDestinationsWarning(!showExternalDestinationsWarning);
  }

  function handleExternalDestinationsWarningContinue() {
    onDeliveryOptionChange(4, true);
    handleExternalDestinationsWarning();
  }

  async function onDeliveryOptionChange(_id, _confirmed=false) {
    if (!deliveryOptionsList.length) { return; }
    let updateList = [];

    let originalHasId4 = companyFirstLoad.delivery_options.some(item => item.id === 4); // check if the company had external dest setup when loaded
    let ask_to_continue = false;

    for (const _val of deliveryOptionsList) {
      if (_val.id === 4 && _id === 4 && _val.checked) { // "External Destinations"
        if (originalHasId4 && !_confirmed && hasDisabledDestinationsOnly) {
          handleExternalDestinationsWarning();
          ask_to_continue = true;
          break;
        }
      }
      if (_val.id === _id) {
        _val.checked = !_val.checked;
      }
      updateList.push(_val);
    }

    if (ask_to_continue) {return;}

    setDeliveryOptionsList(updateList);
  }

  const handleChangeLicenseOverride = (ev) => {
    setCompany({...company, override_license_requirement: !company.override_license_requirement});
    if(ev.target.checked) {
      setShowLicenseOverrideModal(true);
    }
  }

  const handleAllowEmbed = () => {
    setCompany({...company, allow_external_embedding: !company.allow_external_embedding});
  }

  const overrideLicenseToggle = () => {
    setShowLicenseOverrideModal(!showLicenseOverrideModal);
  }

  const activeSubCompanyWarningToggle = () => { 
    setShowActiveSubCompanyWarning(!showActiveSubCompanyWarning);
  }

  const activeSubCompanyWarningOnDeleteToggle = () => { 
    setShowActiveSubCompanyWarningOnDelete(!showActiveSubCompanyWarningOnDelete);
  }

  const handleAllowSubCompanies = () => {
    if (activeSubCompanies < 1) { 
      setCompany({...company, allow_sub_companies: !company.allow_sub_companies, approved_sub_company_count: company.approved_sub_company_count || default_subcompanies_allowed});
    } else {
      activeSubCompanyWarningToggle();
    }
  }

  const handleLinkCostToParent = (e) => { 
    if (e.target.checked) { 
      setCompany({...company, order_cost_limits: [], enable_order_cost_limit: false, link_order_cost_limit_to_parent: true});
    } else {
      setCompany({...company, link_order_cost_limit_to_parent: false});
    }
  }

  const handleAllowCostLimits = (e) => { 
    const costLimit = e.target.checked ? costLimits : [];
    if (e.target.checked) {
      setShowOrderCostOptions(true);
      setCompany({...company, enable_order_cost_limit: !company.enable_order_cost_limit, order_cost_limits: costLimit});
    } else if(!e.target.checked && costLimits.length) {
      setShowOrderLimitWarning(true);
    } else {
      setCompany({...company, enable_order_cost_limit: false, order_cost_limits: []});
      handleOrderLimitWarningContinue();
    }
  }
  
  const handleOrderLimitWarningContinue = () => {
    setShowOrderLimitWarning(false);
    setCostLimits([]);
    setCompany({...company, enable_order_cost_limit: false, order_cost_limits: []});
  }

  const handleUpdateCostLimit = (newLimits) => { 
    let updatedLimits = [];
    newLimits.forEach((item) => {
      if (item.dollar_limit) {
        updatedLimits.push({ order_cost_limit_period_id: item.order_cost_limit_period_id, dollar_limit: item.dollar_limit });
      }
    });
    setCompany({...company, order_cost_limits: updatedLimits});
  }

  const handleLinkPricing = () => {
    setCompany({...company, link_pricing_to_parent: !company.link_pricing_to_parent});
  }

  const handleSubmitLicenseOverrideReason = (_reason) => {
    setOverrideLicenseReason(_reason);
  }

  const handleCancelLicenseOverrideReason = () => {
    setCompany({...company, override_license_requirement: false});
  }

  const handleChangeDisableBanner = (ev) => {
    setCompany({...company, disable_banner: !company.disable_banner});
  }

  const handleChangeDemoInstance = (ev) => {
    setCompany({...company, demo_instance: !company.demo_instance});
  }

  const handleChangeColorScheme = (ev) => {
    const selected = colorSchemeOptions.find((s) => String(s.id) === ev.target.value);
    setCompany({...company, color_scheme: selected || null});
  }

  const handleShowSubCompanyOptions = () => {
    setShowSubCompanyModal(!showSubCompanyModal);
  }

  const handleShowOrderCostOptions = () => {
    setShowOrderCostOptions(!showOrderCostOptions);
  }

  const handleHideOrderCostOptions = (cancel) => { 
    if (cancel && !costLimits.length) { 
      setCompany({ ...company, enable_order_cost_limit: false, order_cost_limits: [] });
    } else {
      setCompany({ ...company, order_cost_limits: costLimits || [] });
    }
    setShowOrderCostOptions(false);
  }

  const handleShowOrderLimitWarning = () => {
    setShowOrderLimitWarning(!showOrderLimitWarning);
  }

  const handleUpdateSubCompanyAllowed = (val) => {
    setCompany({...company, approved_sub_company_count: Number(val)});
    handleShowSubCompanyOptions();
  }

  const checkDataDeliveryIsValid = () => {
    let isValid = false;
    deliveryOptionsList.forEach(val => {
      if(val.checked) {
        isValid = true;
      }
    });
    return isValid;
  }

  useEffect(() => {
    let _selected = deliveryOptionsList.filter(item => item.checked);
    setCompany({ ...company, delivery_options: _selected });
    if (hasDestinationsInUse || (_selected?.length && _selected.some(item => item.id === 4 && item.checked))) { // "External Destinations"
      checkIfExternalDestinationsInUse();
    }
    // eslint-disable-next-line
  }, [deliveryOptionsList])

  const getPricingToDisplay = () => {
    if(company.link_pricing_to_parent) {
      // linked: set pricing same as parent - not editable
      setCompany({...company, pricing: parentCompanyInfo.pricing});
      setSelectedInvoiceCategories(parentCompanyInfo.pricing);
    } else if(companyFirstLoad.link_pricing_to_parent) {
      // unlinked: but the original was linked: show parents editable pricing
      let _new_pricing = parentCompanyInfo.pricing.map(item => ({ ...item }));
      setCompany({...company, pricing: _new_pricing});
      setSelectedInvoiceCategories(_new_pricing);
    } else {
      // NOT linked: leave pricing as is
      let _new_pricing = companyFirstLoad.pricing.map(item => ({ ...item }));
      setCompany({...company, pricing: _new_pricing});
      setSelectedInvoiceCategories(_new_pricing);
    }
  }

  useEffect(() => {
    if(parentCompanyInfo && parentCompanyInfo.id) {
      getPricingToDisplay();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [company.link_pricing_to_parent, parentCompanyInfo])

  useEffect(() => {
    if (!isLoadingCompany && companyFirstLoad === null) {
      let temp_company = JSON.parse(JSON.stringify(company));
      if(company && company.parent) {
        temp_company = {
          ...temp_company,
          demo_instance: company.parent.demo_instance
        };
        setCompanyFirstLoad(temp_company);
      } else {
        setCompanyFirstLoad(JSON.parse(JSON.stringify(company)));
      }
      setInitialLoadComplete(true);
      setMissingFields(true);
      setErrors(prev => ({ ...prev, 
        name: company.name ? "" : "*Required",
        code: company.code ? "" : "*Required",
        qb_name: company.qb_name ? "" : "*Required",
        delivery_options: company.delivery_options ? "" : "*Required",
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoadingCompany, company, companyFirstLoad]);

  useEffect(() => {
    let basic_fields = (({ name, code, qb_name, sftp_directory }) => ({ name, code, qb_name, sftp_directory }))(company);
    if (company.id) {
      // handle edit company
      setHasUnsavedChanges(!missingFields);
    } else if( Object.values(basic_fields).some(value => value !== "") ) {
      // handle new company
      setHasUnsavedChanges(true);
    } else {
      setHasUnsavedChanges(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [company, missingFields])

  useEffect(() => {
    if(companyFirstLoad && company) {
      if(company.link_pricing_to_parent && !companyFirstLoad.link_pricing_to_parent) {
        setShowLinkUncheckedWarning(false);
        setShowLinkedWarning(true);
      } else if(!company.link_pricing_to_parent && companyFirstLoad.link_pricing_to_parent){
        setShowLinkUncheckedWarning(true);
        setShowLinkedWarning(false);
      } else {
        setShowLinkUncheckedWarning(false);
        setShowLinkedWarning(false);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [company.link_pricing_to_parent, companyFirstLoad])

  useEffect(() => {
    if(initialLoadComplete) {
      // set the checkbox field to match the parents
      if(company && company.parent) {
        setTimeout(() => {
          setCompany({...company, demo_instance: company.parent.demo_instance});
          setDisableDemoField(true);
        }, 600);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialLoadComplete])

  useEffect(() => {
    if(companyFirstLoad) {
      // get external destinations info
      checkIfExternalDestinationsInUse();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companyFirstLoad])

  /* wait until done loading data before rendering */
  if((isLoadingCompany || !initialLoadComplete) && props.args.company_id) {
    return (
      <div className="page admin-page">
        <div className="list-header sticky-page-header">
          <Link to="/admin-companies">
            <button type="button" className="new-button">
              <i className="bi bi-chevron-left"></i> Companies
            </button>
          </Link>
          <h1>Company Details</h1>
          <i className="spacer" />
        </div>
        <div className="loading-text">Loading</div>
        <section className="loading-wrapper">
          <span style={animatedStyle}>
            <ProgressLoader />
          </span>
        </section>
      </div>
    )
  }

  function onClickDeleteCompany() {
    if(activeSubCompanies > 0) {
      setShowActiveSubCompanyWarningOnDelete(true);
      return;
    }
    setShowDeleteModal(!showDeleteModal);
  }

  function onSubmitDelete(_reason) {
    let companyData = {
      company_id: company.id,
      reason: _reason
    }
    if(company.id) {
      session.command("companies/delete", 
        companyData, 
        {}, { defaultErrorHandling: false })
        .then((response) => {
          setSoftErrors(response.soft_errors || []);
            if (!response?.soft_errors?.length) {
              onClickDeleteCompany();
              setShowSuccess(true);
              setTimeout(() => {
                setShowSuccess(false);
                history.push(`/admin-companies`);
              }, 2000);
            }
        })
        .catch((error) => {
          onClickDeleteCompany();
          console.log("Failed to delete company", JSON.stringify(error));
        });
    }
  }

  return (
    <div className="page admin-page">
      <div className="list-header sticky-page-header">
        <Link to="/admin-companies">
          <button type="button" className="new-button">
            <i className="bi bi-chevron-left"></i> Companies
          </button>
        </Link>
        <h1>Company Details</h1>
        <i className="spacer" />
      </div>
      <Form className="company-form-page" onSubmit={e => e.preventDefault()}>
        <section className="company-form-details">
          <div className="fields-wrapper">
            <Field
              label="* Name"
              className="company-form-details-heading"
              error={errors.name}
            >
              <input
                type="text"
                value={company.name}
                className="company-form-details-info"
                onChange={setName}
                onBlur={() => {
                  if(!company.name) {
                    setErrors(prev => ({ ...prev, name: "*Required" }));
                  }
                }}
              />
            </Field>

            <Field
              label="* Code"
              className="company-form-details-heading"
              error={errors.code}
            >
              <input
                type="text"
                value={company.code}
                className="company-form-details-info"
                onChange={setCode}
                onBlur={() => {
                  if(!company.code) {
                    setErrors(prev => ({ ...prev, code: "*Required" }));
                  } else {
                    setErrors(prev => ({ ...prev, code: "" }));
                  }
                }}
              />
            </Field>

            <Field
              label="* QuickBooks Name"
              className="company-form-details-heading"
              error={errors.qb_name}
            >
              <input
                type="text"
                value={company.qb_name}
                className="company-form-details-info"
                onChange={setQbName}
                onBlur={() => {
                  if(!company.qb_name.length) {
                    setErrors(prev => ({ ...prev, qb_name: "*Required" }));
                  }
                }}
              />
            </Field>

            <Field
              label="&nbsp; Invoices"
              className="company-form-details-heading"
            >
              <span className="company-form-details-info">
                <NextInvoiceFormat nextInvoice={nextInvoice} />
              </span>
            </Field>

            {props.args.company_id &&
              <div className="dropdown-option">
                <SearchableDropdown
                  options={companyLocations}
                  selectedValue={setHqLocation}
                  preset={company.headquarter_location}
                />
              </div>
            }

            <div className="delivery-form form-controls radio mt-3">
              <Field
                label="Disable Banner"
                className="company-form-details-heading"
              >
                <FormGroup inline check>
                  <input
                    type="checkbox"
                    checked={company.disable_banner}
                    onChange={handleChangeDisableBanner}
                    disabled={!access('order_edit')}
                  />
                  <InfoPopover 
                    title="Disable Banner" 
                    message="By selecting this option, the AudienceMaker banner will not show. This will prevent logging out or changing to a different company." 
                  />
                </FormGroup>
              </Field>
            </div>

            <div className="delivery-form form-controls radio mt-3">
              <Field
                label="Demo Instance"
                className="company-form-details-heading"
              >
                <FormGroup inline check>
                  <input
                    type="checkbox"
                    checked={company.demo_instance}
                    onChange={handleChangeDemoInstance}
                    disabled={!access('order_edit') || disableDemoField}
                  />
                  <InfoPopover
                    title="Demo Instance"
                    message={disableDemoField ? "This setting is controlled by the parent company." : "By selecting this option, all orders placed for this company will NOT be invoiced and will NOT have royalties reported."}
                  />
                </FormGroup>
              </Field>
            </div>

            <div className="delivery-form form-controls radio mt-3">
              <Field
                label="Logo and Color Scheme"
                className="company-form-details-heading"
              >
                <FormGroup inline check>
                  <Input
                    type="select"
                    value={company.color_scheme?.id ?? ''}
                    onChange={handleChangeColorScheme}
                    disabled={!access('order_edit')}
                    style={{ width: 'auto', display: 'inline-block' }}
                  >
                    <option value="" disabled>Select...</option>
                    {colorSchemeOptions.map(({ id, name }) => (
                      <option key={id} value={id}>{name}</option>
                    ))}
                  </Input>
                  <InfoPopover
                    title="Logo and Color Scheme"
                    message="Controls the branding (logo, colors) shown to this company's users. New sub-companies default to their parent's setting."
                  />
                </FormGroup>
              </Field>
            </div>

            {!company.demo_instance ? (<>
            {!company.parent_name && (
              <div className="delivery-form form-controls radio mt-3 override-license">
                <Field
                  label="Override License Requirement"
                  className="company-form-details-heading"
                >
                  <FormGroup inline check>
                    <input
                      type="checkbox"
                      checked={company.override_license_requirement}
                      onChange={handleChangeLicenseOverride}
                      disabled={!access('order_edit')}
                    />
                    <InfoPopover 
                      title="Override License Requirement" 
                      message="By selecting this option, Company will be able to place an order without an active license." 
                    />
                  </FormGroup>
                </Field>
              </div>
            )}

            <div className="delivery-form form-controls radio mt-3 override-license">
              <Field
                label="Enable Sub-Companies"
                className="company-form-details-heading"
              >
                <FormGroup inline check>
                  {company.parent_name ? <span className="sub-company-options">
                    This is a sub-company of <strong>{company.parent_name}</strong></span> : 
                  <>
                    <input
                      type="checkbox"
                      checked={company.allow_sub_companies}
                      onChange={handleAllowSubCompanies}
                    />
                    <InfoPopover 
                      title="Allow Sub-Companies" 
                      message="By selecting this option, the user will have the ability to create sub-companies for this parent company." 
                    />
                    {company.allow_sub_companies && (<>
                      <span className="display-allowed">Sub-Companies Allowed: <strong>{company.approved_sub_company_count || default_subcompanies_allowed}</strong></span>
                      <button 
                        type="button" title="Edit Sub-Companies Options" 
                        className="btn btn-sm sub-company-options-btn" 
                        onClick={handleShowSubCompanyOptions}
                      >
                        <i className="bi bi-pencil" /> Edit Options
                      </button>
                    </>)}
                  </>}
                </FormGroup>
              </Field>
            </div>

            {company.parent_name && <>
              <div className="delivery-form form-controls radio mt-3 override-license">
                <Field
                  label="Link Pricing to Parent Account"
                  className="company-form-details-heading"
                >
                  <FormGroup inline check>
                    <>
                      <input
                        type="checkbox"
                        checked={company.link_pricing_to_parent}
                        onChange={handleLinkPricing}
                      />
                      <InfoPopover 
                        title="Link Pricing to Parent Account" 
                        message="By selecting this option, any pricing changes made to the Parent Company pricing will automatically be applied to this sub-company." 
                      />
                    </>
                  </FormGroup>
                </Field>
              </div>
              <div className="mt-2 link-price-warning-section">
              {showLinkUncheckedWarning && 
                <Alert color="warning">
                  <i className="bi bi-exclamation-octagon" /> By de-selecting this option, any future pricing changes made to the Parent Company will not be automatically applied to this sub-company.
                </Alert>
              }
              {showLinkedWarning &&
                <Alert color="warning">
                  <i className="bi bi-exclamation-octagon" /> Warning: any custom pricing for this sub-company will be removed and will be reverted to the pricing set at the parent company.
                </Alert>
              }
              </div>
              </>}
              {company.parent_name &&
                <div className="cost-limits-form form-controls radio mt-3 override-license">
                  <Field
                    label="Link Order Cost Limit to Parent Account"
                    className="company-form-details-heading"
                  >
                    <FormGroup inline check>
                      <>
                        <input
                          type="checkbox"
                          checked={company.link_order_cost_limit_to_parent}
                          onChange={e => handleLinkCostToParent(e)}
                        />
                        <InfoPopover
                          title="Link Order Cost Limit to Parent Account"
                          message="By checking this box, Order Cost Limit will tie to the parent account."
                        />
                      </>
                    </FormGroup>
                  </Field>
                </div>
              }
              {!company.link_order_cost_limit_to_parent &&
                <div className="cost-limits-form form-controls radio mt-3 override-license">
                  <Field
                    label="Enable Order Cost Limits"
                    className="company-form-details-heading"
                  >
                    <FormGroup inline check>
                      <>
                        <input
                          type="checkbox"
                          checked={company.enable_order_cost_limit && company.order_cost_limits.length}
                          onChange={e => handleAllowCostLimits(e)}
                        />
                        <InfoPopover
                          title="Enable Order Cost Limits"
                          message="Maximum dollar amount company can place based on the selected time frames."
                        />
                      </>
                      {company.enable_order_cost_limit &&
                        <button
                          type="button" title="Edit Order Limit Options"
                          className="btn btn-sm sub-company-options-btn"
                          onClick={handleShowOrderCostOptions}
                        >
                          <i className="bi bi-pencil" /> Edit Options
                        </button>
                      }
                    </FormGroup>
                  </Field>
                </div>
              }
            {company.enable_order_cost_limit && (<>
                <CostLimitList
                  toggle={handleHideOrderCostOptions}
                  show={showOrderCostOptions}
                  costLimits={costLimits || []}
                  limitOptions={costLimitOptions || []}
                  onChange={handleUpdateCostLimit}
                />
              </>)}
              {costLimits?.length > 0 && (<>
                <div className="cost-limit-table">
                    <Table>
                        <thead>
                          <tr>
                            <th>Time Frame</th>
                            <th>Dollar Limit</th>
                          </tr>
                        </thead>
                        <tbody>
                          {costLimitOptions.length > 0 && costLimitOptions.map((item, index) => {
                            let _option = costLimits.find(option => option.order_cost_limit_period_id === item.id || 
                              option.order_cost_limit_period_id === item.order_cost_limit_period_id
                            );
                            if (_option) { 
                              return (
                                <tr key={index}>
                                  <td>{item.label}</td>
                                  <td>{"$" + _option?.dollar_limit.toLocaleString("en-US")}</td>
                                </tr>
                              )
                            }
                            return null;
                          })}
                          </tbody>
                    </Table>
                  </div>
                    </>)}
              
            <div className="company-form dropdown-option form-field">
              <Field
              label="* Data Delivery"
              className="company-form-details-heading"
              ></Field>

              <div className="delivery-form form-controls radio">
                {deliveryOptionsList && deliveryOptionsList.map((_option) => {
                  return (
                    <FormGroup inline key={_option.id} check>
                      <input
                        type="checkbox"
                        value={_option.name}
                        checked={_option.checked}
                        onChange={() => onDeliveryOptionChange(_option.id)}
                        disabled={!access('order_edit') || (hasDestinationsInUse && _option.id === 4)} // disable "External Destinations" if in use
                      />
                      <label className={`nowrap ${_option.id === 4 && hasDestinationsInUse ? 'info' : ''}`}>
                        {_option.name}
                        {_option.id === 4 && hasDestinationsInUse && 
                          <div className="dest-info">
                            <InfoPopover
                              title="External Destinations In Use" 
                              message={externalDestinationsMessage}
                            />
                          </div>
                          }
                      </label>
                    </FormGroup>
                  )
                })}
                {!checkDataDeliveryIsValid() ? <span className="text-danger">*REQUIRED</span> : ""}
              </div>
            </div>
            {company.delivery_options.some(item => /SpeedeonSFTP/i.test(item.name)) &&
            <div className="company-form dropdown-option form-field">
              <Field
                label="* SFTP Directory"
                className="company-form-details-heading"
              ></Field>
              <FormGroup inline>
                <Input
                  invalid={sftpValidationResponse.length > 0 && company.delivery_options.some(item => /SpeedeonSFTP/i.test(item.name))}
                  valid={validSftp && newSftpDir !== "" && (newSftpDir !== companyFirstLoad.sftp_directory)}
                  type="text"
                  value={newSftpDir}
                  className="company-form-details-info sftp-input"
                  onChange={handleSftpDirChange}
                />
                <button 
                  type="button" className={['sm-btn-base', disableSftpCheck ? '' : 'sm-btn-pink'].join(' ')}
                  disabled={disableSftpCheck}
                  onClick={validateSftpDirectory}>
                  Check SFTP Directory
                </button>
                
                {isValidatingSftp ? (<>
                  <span className="spinner-border spinner-border-sm" role="status" />{" "} 
                  <span className="smaller-text">Checking...</span>
                </>) : <span className="smaller-text">{sftpValidationResponse}</span>}
              </FormGroup>
              <div className="sftp-info">
                <InfoPopover 
                  title="SFTP Directory" 
                  message="When selecting the SFTP option, the directory name must exists on the SFTP server. If the validation fails please work with Operations to verify the directory name." 
                />
              </div>
            </div>
            }
            <div className="delivery-form form-controls radio mt-3 override-license">
              <Field
                label="Allow External AudienceMaker Embedding"
                className="company-form-details-heading"
              >
                <FormGroup inline check>
                  <input
                    type="checkbox"
                    checked={company.allow_external_embedding}
                    onChange={handleAllowEmbed}
                    disabled={!access('order_edit')}
                  />
                  <InfoPopover 
                    title="External AudienceMaker Embedding" 
                    message="By selecting this option, the company has the ability to embed AudienceMaker externally." 
                  />
                </FormGroup>
              </Field>
            </div>

            </>) : <div className="mb-1">&nbsp;</div>}

          </div>
          <SoftErrorModal
            isOpen={showSoftErrorModal}
            show={showSoftErrorModal}
            title="Error"
            body="Something went wrong while processing your request, and some or all of your changes were not saved. Please review your updates and try again."
            toggle={toggleSoftErrorModal}
          />
          <ManageSubCompanyOptions 
            show={showSubCompanyModal} 
            cancel={handleShowSubCompanyOptions}
            initialValue={company.approved_sub_company_count}
            update={handleUpdateSubCompanyAllowed}
            default_allowed={default_subcompanies_allowed}
          />
          <div className="company-form-buttons">
            <button
              className="save-button"
              onClick={createBuckets}
              disabled={createBucketsDisabled}
            >
              Create Azure Buckets
            </button>
            {company.id && (<>
              <Link to={`/admin-company-api-access#company_id=${company.id}`}>
                <button
                  type="button"
                  className="save-button"
                  disabled={!company.id}
                >
                  Manage API Access
                </button>
              </Link>
              {!company.parent_name &&
                <Link to={`/admin-company-license#company_id=${company.id}`}>
                  <button
                    type="button"
                    className="save-button"
                    disabled={!company.id || company.demo_instance}
                  >
                    Manage Licenses
                  </button>
                </Link>
              }
            </>)}
            <button
              className="save-button promote"
              onClick={onClickSave}
              disabled={missingFields}
            >
              Save Changes
            </button>
          </div>
        </section>

        <div className="company-delete-button">
          {company.id && access('administration') && (
            <div className="delete-company-section mt-5">
              <fieldset className="danger-zone">
                <legend>&nbsp; Danger Zone &nbsp;</legend>
                <div className="mb-3">By selecting Delete Company, you will <b>permanently delete</b> all users, uploads, locations, models, and audiences associated with this company.</div>
                <div className="delete-btn-wrapper">
                  <Button
                    color="danger"
                    outline
                    className="btn-red-error"
                    onClick={onClickDeleteCompany}
                  >Delete Company</Button>
                </div>
              </fieldset>
            </div>
          )}
        </div>

        <DualSelect
          name={"Custom Pricing"}
          optionLabel="name"
          allOptions={allInvoiceCategories}
          availableOptionsRender={(o) => (
            <Field label={`${o.name}(${get_display_channel_options(o)})`}>
              <input
                type="text"
                disabled
                value={o.unit_price}
                className="user-form-details-info"
              />
            </Field>
          )}
          selectedOptions={selectedInvoiceCategories}
          setSelectedOptions={setSelectedInvoiceCategories}
          selectedOptionsRender={(o) => (
            <Field label={`${o.name}(${get_display_channel_options(o)})`} className="user-form-details-heading">
              <input
                type="number"
                value={o.value}
                className="user-form-details-info no-arrows"
                onChange={(ev) => {
                  ev.stopPropagation();
                  ev.preventDefault();
                  updateInvoiceCategoryValue(ev, o.id);
                }} 
                disabled={company.link_pricing_to_parent}
                onBlur={(ev) => {
                  ev.stopPropagation();
                  ev.preventDefault();
                  if(o.value === "") {
                    // use the value '0' if user leaves it blank
                    updateInvoiceCategoryValue({target: {value: "0"}}, o.id);
                  }
                }}
                onWheel={(e) => e.target.blur()} 
              />
            </Field>
          )}
          showSelectionOnly={company.link_pricing_to_parent}
        />

        <DualSelect
          name={"Data Permissions"}
          allOptions={allDataPermissions}
          selectedOptions={selectedDataPermissions}
          setSelectedOptions={setSelectedDataPermissions}
          selectedOptionsRender={(o) => (
            <Field label={o.name} className="user-form-details-heading">
              <input
                type="text"
                value={o.value}
                className="user-form-details-info"
                onChange={(ev) => updateDataPermissionsValue(ev, o.id)}
              />
            </Field>
          )}
        />
      </Form>
      {isUploading && (
        <>
          <div style={loaderStyle} />
          <div style={textStyle}>
            {updatingMessage}
            {updateSuccess ? (
              <i className="bi bi-check-lg" />
            ) : (
              <span style={animatedStyle}>
                <ProgressLoader />
              </span>
            )}
          </div>
        </>
      )}
      <ConfirmDeleteCompany 
        show={showDeleteModal}
        onHide={()=> setShowDeleteModal(!showDeleteModal)}
        onSubmit={onSubmitDelete}
        company={company.name}
      />
      <ConfirmSuccess show={showSuccess} label="Company deleted successfully." />
      <ActiveCompanyOrderLimitWarning
        show={showOrderLimitWarning}
        onHide={handleShowOrderLimitWarning}
        onContinue={handleOrderLimitWarningContinue}
      />
      <ConfirmOverrideLicense 
        show={showLicenseOverrideModal} 
        onHide={overrideLicenseToggle} 
        onSubmit={handleSubmitLicenseOverrideReason}
        onCancel={handleCancelLicenseOverrideReason}
        preSetText={company.override_license_requirement_reason || ""}
      />
      <ActiveSubCompanyWarning
        show={showActiveSubCompanyWarning}
        onHide={() => activeSubCompanyWarningToggle}
      />
      <ActiveSubCompanyWarningOnDelete
        show={showActiveSubCompanyWarningOnDelete}
        onHide={() => activeSubCompanyWarningOnDeleteToggle}
      />
      <AskToConfirmUncheckExternalDestinations
        show={showExternalDestinationsWarning}
        onHide={handleExternalDestinationsWarning}
        onContinue={handleExternalDestinationsWarningContinue}
      />
      <UnsavedChanges hasUnsavedChanges={hasUnsavedChanges} />
    </div>
  );
}

/**
 * 
 * check how long it's left until the current license expires
 * if more than 30: returns the start date plus 1 month as next invoice date
 * if less than 30: returns message showing when it will end
 */
function NextInvoiceFormat({nextInvoice}) {
  const invoiceDateStyle = {
    'textTransform': 'none'
  }

  if(nextInvoice) {
    const {start_date, end_date} = nextInvoice;
    if (!start_date) {
      return (
        <span style={invoiceDateStyle}>No Future Invoice Found</span>
      )
    }

    const today = dayjs();
    const end = dayjs(end_date);
    const timeLeft = end.diff(today);
    const days_left = timeLeft / (1000 * 3600 * 24);
    const nextDate = dayjs(start_date).add(1, 'month');

    const displayEnd = dayjs(end).format('MMMM DD YYYY');
    const displayNext = dayjs(nextDate).format('MMMM DD YYYY');

    if(Math.floor(days_left) <= 30) {
      return (
        <span style={invoiceDateStyle}>Current License Ends On: {displayEnd}</span>
      )
    } else if(Math.floor(days_left) > 0) {
      return (
        <span style={invoiceDateStyle}>Next Invoice Date: {displayNext}</span>
      )
    }
  };

  return (
    <span style={invoiceDateStyle}>No Future Invoice Found</span>
  )  
};

/**
 * confirm and reason to disable company
 */
export function ConfirmDeleteCompany(props) {
  const { show = false, onHide, onSubmit, company } = props;
  const [dropdownChoice, setDropdownChoice] = useState("");
  const [textValue, setTextValue] = useState("");
  const [showOtherArea, setShowOtherArea] = useState(false);
  const [reason, setReason] = useState("");
  const [nameValue, setNameValue] = useState("");
  const [disableSubmitBtn, setDisableSubmitBtn] = useState(true);
  const [showNameRequired, setShowNameRequired] = useState(true);
  const [showReasonRequired, setShowReasonRequired] = useState(true);

  const options = [
    "Canceled Contract",
    "Contract Not Renewing",
    "Demo Instance",
    "Other (explain)",
  ];

  const handleTextAreaChange = (event) => {
    setTextValue(event.target.value);
  };

  const handleSave = () => {
    onSubmit(reason);
  }

  const handleDropdownChoice = (choice) => {
    setDropdownChoice(choice);
  }

  useEffect(() => {
    // ask for 'other' details
    if(dropdownChoice.includes("(explain)")) {
      setShowOtherArea(true);
      setReason(textValue);
    } else {
      setShowOtherArea(false);
      setReason(dropdownChoice);
      if(dropdownChoice.length > 3) {
        setTextValue("");
      }
    }
  }, [dropdownChoice, textValue])

  useEffect(() => {
    let name_isMatch = false;
    let reason_isSet = false;

    // check if the name typed in matches the company name
    let match = `DELETE ${company}`;
    if(nameValue.length && match.length && nameValue === match) {
      name_isMatch = true;
    }

    // check if there is a reason selected
    if(dropdownChoice.includes("(explain)")) {
      if(textValue.length > 24 && textValue.length < 201) {
        reason_isSet = true;
      }
    } else if(dropdownChoice.length) {
      reason_isSet = true;
    }

    // show required
    name_isMatch ? setShowNameRequired(false) : setShowNameRequired(true);
    reason_isSet ? setShowReasonRequired(false) : setShowReasonRequired(true);
    
    // disable the delete button if fields are missing
    if(name_isMatch && reason_isSet) {
      setDisableSubmitBtn(false);
    } else {
      setDisableSubmitBtn(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nameValue, dropdownChoice, textValue])

  const handleCancel = () => {
    setTextValue("");
    setNameValue("");
    setDropdownChoice("");
    onHide();
  }

  return (
    <Modal isOpen={show} className="reason-modal">
      <div className="modal-header">
        <h4>Confirm Delete Company</h4>
      </div>
      <div className="modal-body reason-textarea">
        <div className="blue-header">
          <label>Company Name:</label>
          <div className="value">{company}</div>
        </div>
        <div className="name-input">
          <p>Please type "DELETE" followed by the company name to confirm the action:
            {showNameRequired && <span className="field-required-error"> *Required</span>}
          </p>
          <input 
            value={nameValue}
            onChange={(e) => setNameValue(e.target.value)}
          />
        </div>
        <br />
        <p>Select a reason: 
          {showReasonRequired && <span className="field-required-error"> *Required</span>}
        </p>
        <SimpleDropdown
          label=" "
          options={options}
          selectedValue={handleDropdownChoice}
          customCss="do-not-invoice-dropdown"
        />
        {showOtherArea && <>
          <textarea
            value={textValue}
            onChange={handleTextAreaChange}
            rows={8}
            placeholder="Type your explanation here..."
          />
          <em>*Please enter between 25 and 200 characters.</em>
        </>}
      </div>
      <div className="modal-footer">
        <Button 
          type="button"
          onClick={handleCancel}
        >Cancel</Button>
        <Button
          color="danger"
          outline
          className="btn-red-error"
          onClick={handleSave}
          disabled={disableSubmitBtn}
        >Delete Company</Button>
      </div>
    </Modal>
  );
}

/**
 * confirm and reason to override license requirement
 */
export function ConfirmOverrideLicense(props) {

  const { show = false, onHide, onSubmit, onCancel, preSetText } = props;

  const [explanationText, setExplanationText] = useState(preSetText);
  const [disableSubmitBtn, setDisableSubmitBtn] = useState(true);

  const handleSave = () => {
    onSubmit(explanationText);
    onHide();
  }

  const handleCancel = () => {
    onCancel();
    onHide();
  }

  const handleTextAreaChange = (event) => {
    let _input = event.target.value;
    // remove extra white spaces
    let cleanedStr = _input.trimLeft().replace(/\s{2,}/g, ' ');
    setExplanationText(cleanedStr);
  };

  useEffect(() => {
    if(explanationText.length >= 10 && explanationText.length < 251) {
      setDisableSubmitBtn(false);
    } else {
      setDisableSubmitBtn(true);
    }
  }, [explanationText])

  return (
    <Modal isOpen={show} className="reason-modal">
      <div className="modal-header">
        <h4>Confirm Override License Requirement</h4>
      </div>

      <div className="modal-body reason-textarea">
        <div className="name-input">
          <p>Explain why Company does not require an Active License to place orders.</p>
        </div>
        <br />
        <textarea
          value={explanationText}
          onChange={handleTextAreaChange}
          rows={8}
          placeholder="Type your explanation here..."
        />
        <em>*Please enter between 10 and 250 characters.</em>
      </div>
      <div className="modal-footer">
        <Button type="button" onClick={handleCancel}>Cancel</Button>
        <Button className="promote" onClick={handleSave} disabled={disableSubmitBtn}>Save</Button>
      </div>
    </Modal>
  );
}

/**
 * returns options for the sub-company
 */
export function ManageSubCompanyOptions({show, cancel, initialValue = 10, update, default_allowed}) {

  const [disableSubmitBtn, setDisableSubmitBtn] = useState(true);
  const [value, setValue] = useState(initialValue);
  const [max] = useState(100);
  const [showValueRangeError, setShowValueRangeError] = useState(false);
  const [showValueWarning, setShowValueWarning] = useState(false);

  useEffect(() => {
    if(initialValue === 0) {
      setValue(default_allowed || 10);
    } else {
      setValue(initialValue);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show])

  const resetAllValues = () => {
    setValue(initialValue);
    setShowValueRangeError(false);
    setShowValueWarning(false);
  }

  const handleCancel = () => {
    resetAllValues();
    cancel();
  }

  const handleChange = (e) => {
    const newValue = e.target.value;
    if(newValue >= 0 && newValue < max) {
      setValue(newValue.replace(/^0+/, ''));
    }
  }

  const handleSave = () => {
    update(value);
    resetAllValues();
  }

  useEffect(() => {
    let bad_value_range = (value < 1 || value > max);
    let value_has_changed = (value.toString() !== initialValue.toString());
    // check value range is valid
    if(bad_value_range) {
      setShowValueRangeError(true);
    } else {
      setShowValueRangeError(false);
    }
    // check value is in range
    if(value > default_allowed && value < max) {
      setShowValueWarning(true);
    } else {
      setShowValueWarning(false);
    }
    // check if save button should be disable
    if(value_has_changed) {
      setDisableSubmitBtn(false);
    } else {
      setDisableSubmitBtn(true);
    }
    if(bad_value_range) {
      setDisableSubmitBtn(true);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value])

  return (
    <Modal isOpen={show} className="reason-modal">
      <div className="modal-header">
        <h4>Manage Sub-Company Options</h4>
      </div>

      <div className="modal-body reason-textarea">
        <div className="mb-3">Number of Approved Sub-Companies:</div>
        <div className="mb-3">
          <input
            type="number"
            value={value}
            onChange={handleChange}
            placeholder="Enter a value..."
            min={0}
            max={max}
          /> {showValueRangeError && <i>*Value entered must be numeric from 1 to {max - 1}</i>}
        </div>
        <div className="mb-3">
          {showValueWarning &&
            <Alert color="warning" className="d-flex">
              <i className="bi bi-exclamation-octagon" /> Allowing resellers access to greater than 10 sub-companies can add additional stress to AudienceMaker. Please notify AudienceMaker Product and Development of this allowance.
            </Alert>
          }
        </div>
      </div>
      <div className="modal-footer">
        <Button type="button" onClick={handleCancel}>Cancel</Button>
        <Button className="promote" onClick={handleSave} disabled={disableSubmitBtn}>Save</Button>
      </div>
    </Modal>
  );
}

export function ActiveSubCompanyWarning(props) { 
  const { show = false, onHide } = props;

  return (
     <Modal centered backdrop
          isOpen={show}
          toggle={onHide()}
      >
        <ModalHeader
          toggle={onHide()}
        >
            <i className="bi bi-exclamation-triangle-fill"></i>Active Sub-Companies
          </ModalHeader>
          <ModalBody>
              This company has active sub-companies. Delete any active sub-companies before disabling sub-company permissions 
          </ModalBody>
          <ModalFooter>
              <Button onClick={onHide()}>Close</Button>
          </ModalFooter>
      </Modal>
  );
}

export function ActiveSubCompanyWarningOnDelete(props) { 
  const { show = false, onHide } = props;

  return (
     <Modal centered backdrop
          isOpen={show}
          toggle={onHide()}
      >
        <ModalHeader
          toggle={onHide()}
        >
            <i className="bi bi-exclamation-triangle-fill"></i>Active Sub-Companies
          </ModalHeader>
          <ModalBody>
            <p>This company has active sub-companies. Delete any active sub-companies before deleting the parent company.</p>
          </ModalBody>
          <ModalFooter>
            <Button onClick={onHide()}>Close</Button>
          </ModalFooter>
      </Modal>
  );
}

export function ActiveCompanyOrderLimitWarning(props) { 
  const { show = false, onHide, onContinue } = props;

  return (
     <Modal centered backdrop
          isOpen={show}
          toggle={onHide}
          onContinue={onContinue}
      >
        <ModalHeader
          toggle={onHide}
        >
          <i className="bi bi-exclamation-triangle-fill"></i>Disable Company Order Cost Limits
          </ModalHeader>
          <ModalBody>
              By de-selecting this box, you will lose all previously saved order cost limits when you save this company.
          </ModalBody>
          <ModalFooter>
              <Button className="promote" onClick={onHide}>Cancel</Button>
              <Button onClick={onContinue}>Continue</Button>
          </ModalFooter>
      </Modal>
  );
}

export function AskToConfirmUncheckExternalDestinations(props) { 
  const { show = false, onHide, onContinue } = props;

  return (
    <Modal centered backdrop isOpen={show}>
      <ModalHeader>
        <i className="bi bi-exclamation-triangle-fill"></i>Unchecking External Destinations
        </ModalHeader>
        <ModalBody>
          <Alert color="warning">
            Warning! By unchecking this box, any disabled destinations will be permanently deleted.<br/>Are you sure you want to proceed?
          </Alert>
        </ModalBody>
        <ModalFooter>
          <Button className="promote" onClick={onHide}>Cancel</Button>
          <Button onClick={onContinue}>Continue</Button>
        </ModalFooter>
    </Modal>
  );
}
